import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]

import { ref, onMounted } from 'vue';
import Tooltip from "bootstrap.native/src/components-v4/tooltip-native";


export default {
  __name: 'tooltip',
  props: {
	title: {type: String, required: true},
	class: {type: String, default: ''},
},
  setup(__props) {

const props = __props;

const el = ref(null);

onMounted(() => {
	new Tooltip(el.value);
})


return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("span", {
    ref_key: "el",
    ref: el,
    class: _normalizeClass(__props.class),
    "data-toggle": "tooltip",
    title: __props.title
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}
}

}